import styled from "styled-components/macro";

export const Typo14Regular = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
export const Typo14Medium = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const Typo16Regular = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const Typo16Medium = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`;

export const Typo18MBold = styled.span`
  font-weight: 800;
  font-size: 18px;
  line-height: 20px;
`;

export const Typo32Medium = styled.span`
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
`;

export const TypoTitle = styled.div`
  font-weight: 600;
  font-size: 72px;
  line-height: 72px;
`;

export const TypoH1 = styled.div`
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
`;

export const TypoH2 = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
`;

export const TypoH3 = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
`;

export const TypoH4 = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
`;

export const TypoH5 = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
`;

export const TypoSubheader = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
`;

export const TypoBodyRegular = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const TypoBodyBold = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`;

export const TypoSmallRegular = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const TypoSmallBold = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const TypoXLRegular = styled.div`
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
`;

export const TypoXLBold = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const TypoCaptionRegular = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -2%;
`;

export const TypoCaptionBold = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -2%;
`;
